import { Box, IconButton, Image, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import { RefillFountainProps } from '../interfaces/components';
import { LoccitaneClose } from '../Icons/LoccitaneClose';
import RefillFountainImage from '../assets/images/RefillFountain.png';
import { Eclipse } from '../Icons/Eclipse';
import { InstructionsLeftArrow } from '../Icons/InstructionsLeftArrow';
import { InstructionsRightArrow } from '../Icons/InstructionsRightArrow';
import Slider from 'react-slick';

export interface RefillFountainImage {
  image: string;
  en: {
    title: string;
    descriptionOne: string;
    descriptionTwo: string;
    descriptionThree: string;
  };
  ar: {
    title: string;
    descriptionOne: string;
    descriptionTwo: string;
    descriptionThree: string;
  };
}

const RefillFountain = ({ activeLocale, active, setActive }: RefillFountainProps) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [slider, setSlider] = useState<any>();
  const [activeImageIndex, setActiveImageIndex] = useState({ oldIndex: 0, newIndex: 0 });

  const refillFountainPicks: RefillFountainImage[] = [
    {
      image: RefillFountainImage,
      en: {
        title: 'Refill Fountain',
        descriptionOne:
          'Respect for the environment is at the heart of L’OCCITANE. From the creation of our formulas to the development of our packaging.',
        descriptionTwo: 'This season, we chose eco-friendly packaging',
        descriptionThree: 'which is in line with the brand commitment “Reducing Waste”.',
      },
      ar: {
        title: 'آلة إعادة التعبئة',
        descriptionOne: '.في موسم الأعياد هذا اخترنا تغليف عبوات صديقة للبيئة',
        descriptionTwo: '.لأن تقليل الهدر، واحترام البيئة، والحفاظ عليها هي من أهم التزامتنا',
        descriptionThree: '',
      },
    },
    {
      image: RefillFountainImage,
      en: {
        title: 'Refill Fountain',
        descriptionOne:
          'L’OCCITANE’s refill fountains are a great way to restock on your favourite products without the extra plastic.',
        descriptionTwo: 'Try them now!',
        descriptionThree: '',
      },
      ar: {
        title: 'آلة إعادة التعبئة',
        descriptionOne:
          '!تشكّل آلات إعادة التعبئة في لوكسيتان طريقة رائعة لتعيد تخزين منتجاتك المفضلة من دون تكديس المواد البلاستيكية. جرّبها الحين',
        descriptionTwo: '!انقر على المضخات لكي ترى كيف تعمل بنفسك',
        descriptionThree: '',
      },
    },
  ];

  const nextSlide = () => {
    slider.slickNext();
  };

  const prevSlide = () => {
    slider.slickPrev();
  };

  const settings = {
    speed: 500,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (oldIndex: number, newIndex: number) => {
      setActiveImageIndex({ oldIndex: oldIndex, newIndex: newIndex });
    },
  };

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex="9"
        onClick={() => {
          setActive();
        }}
      />

      <Box
        zIndex="10"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        bg="white"
        padding={['15px', '20px', '25px', '25px']}
        width={['80vw', '360px', '400px', '950px', '950px']}
        height={['550px', '580px', '630px', '500px', '550px']}
      >
        <LoccitaneClose
          boxSize={[6, 6, 8]}
          position="absolute"
          top={['25px', '30px', '35px']}
          right={['25px', '30px', '35px']}
          cursor="pointer"
          fill="black"
          strokeWidth={0.5}
          onClick={() => {
            setActive();
          }}
          zIndex={30}
          stroke="#CCCCCC"
          borderRadius="100%"
          _hover={{ stroke: 'black' }}
          transition=".5s"
        />

        <Box
          border="5px solid #FFCB00"
          width="100%"
          display="flex"
          flexDirection={['column', 'column', 'column', 'row', 'row']}
          justifyContent={['center', 'space-between', 'space-between', 'center', 'center']}
          alignItems="center"
          height="100%"
        >
          <Box w={['100%', '100%', '100%', '450px', '450px']} h={['220px', '250px', '270px', '440px', '490px']}>
            <Slider ref={(slider) => setSlider(slider)} {...settings}>
              {refillFountainPicks?.map((image: RefillFountainImage, index: number) => (
                <Image
                  key={index}
                  w={['100%', '100%', '100%', '450px', '450px']}
                  h={['220px', '250px', '270px', '490px', '490px']}
                  objectFit="cover"
                  src={image.image}
                />
              ))}
            </Slider>
          </Box>
          <Box
            textAlign="center"
            w={['100%', '450px', '100%', '450px', '450px']}
            h={['290px', '310px', '310px', '500px', '550px']}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Box
              h={['210px', '180px', '200px', '300px', '350px']}
              mb={['5px ', '5px', '5px', '20px', '20px']}
              display="flex"
              justifyContent="space-around"
              flexDirection="column"
            >
              <Text
                m="0 auto"
                fontSize={['23px', '23px', '25px', '40px', '40px']}
                lineHeight={['23px', '23px', '25px', '40px', '40px']}
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'LoccitaneRegular'}
                fontWeight="500"
              >
                {activeLocale === 'ar'
                  ? refillFountainPicks[activeImageIndex.newIndex].ar.title
                  : refillFountainPicks[activeImageIndex.newIndex].en.title}
              </Text>
              <Text
                m="0 auto"
                w={['90%', '280px', '320px', '330px', '330px']}
                fontSize={['13px', '13px', '14px', '20px', '20px']}
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
              >
                {activeLocale === 'ar'
                  ? refillFountainPicks[activeImageIndex.newIndex].ar.descriptionOne
                  : refillFountainPicks[activeImageIndex.newIndex].en.descriptionOne}
              </Text>
              <Text
                m="0 auto"
                w={['90%', '280px', '320px', '330px', '330px']}
                fontSize={['13px', '13px', '14px', '20px', '20px']}
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
                color="#FDC506"
              >
                {activeLocale === 'ar'
                  ? refillFountainPicks[activeImageIndex.newIndex].ar.descriptionTwo
                  : refillFountainPicks[activeImageIndex.newIndex].en.descriptionTwo}
              </Text>
              {activeLocale === 'ar'
                ? refillFountainPicks[activeImageIndex.newIndex].ar.descriptionThree.length > 0
                : refillFountainPicks[activeImageIndex.newIndex].en.descriptionThree.length > 0 && (
                    <Text
                      m="0 auto"
                      w={['90%', '280px', '320px', '330px', '330px']}
                      fontSize={['13px', '13px', '14px', '20px', '20px']}
                      fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
                    >
                      {activeLocale === 'ar'
                        ? refillFountainPicks[activeImageIndex.newIndex].ar.descriptionThree
                        : refillFountainPicks[activeImageIndex.newIndex].en.descriptionThree}
                    </Text>
                  )}
            </Box>

            <Box
              display="flex"
              flexDirection="row"
              justifyContent="center"
              alignItems="center"
              h="auto"
              mb={['10px', '10px', '15px', '20px', '20px']}
            >
              {refillFountainPicks.map((image: RefillFountainImage, index: number) => (
                <Eclipse
                  borderRadius="100%"
                  key={image.image + index}
                  m="0px 5px"
                  boxSize={[2, 2, 3]}
                  strokeWidth="2"
                  stroke={activeImageIndex.newIndex === index ? '#FFD220' : '#D9D9D9'}
                  fill={activeImageIndex.newIndex === index ? '#FFD220' : 'white'}
                  onClick={() => {
                    slider.slickGoTo(index);
                  }}
                  cursor="pointer"
                />
              ))}
            </Box>

            <Box
              w={['150px', '170px', '170px', '170px', '170px']}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <IconButton
                variant="outline"
                aria-label="Move Left"
                onClick={prevSlide}
                height={['30px', '40px', '40px', '40px', '40px']}
                width={['70px', '80px', '80px', '80px', '80px']}
                borderRadius="0px"
                icon={<InstructionsLeftArrow boxSize={[6, 8, 10]} />}
              />

              <IconButton
                variant="outline"
                aria-label="Move Left"
                onClick={nextSlide}
                height={['30px', '40px', '40px', '40px', '40px']}
                width={['70px', '80px', '80px', '80px', '80px']}
                borderRadius="0px"
                icon={<InstructionsRightArrow boxSize={[6, 8, 10]} />}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};
export default RefillFountain;
